module.exports = __webpack_public_path__ + "static/media/Cementos Artigas.de5e8431.jpg";